<template>
  <div class="block-list">
    <bim-text type="h5" class="block-list__title" bold>{{ list.title }}</bim-text>
    <div
      v-for="(item, index) of list.items"
      :key="index"
    >
      <bim-text type="accent" bold class="pt-10 pb-0 pb-sm-9 block-list__item-title" v-html="item.title"></bim-text>
      <div v-for="list_item of item.items" :key="list_item" class="d-flex align-start pt-6 pt-sm-4">
        <img alt="plus" src="/dist/assets/front_white/img/about_lending/special-plus.svg" class="block-list__plus-icon" />
        <bim-text type="main" class="pl-3 block-list__item-text" v-html="list_item"></bim-text>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlockList",
  props: {
    /**
     * @type { { title: String, items: Array<{ title: String, items: Array<String> }> }
     */
    list: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.block-list {

  ::v-deep .text__inner {
    font-size: inherit !important;
  }

  .block-list__title {
    font-size: 32px;
    line-height: 1.13;
  }

  .block-list__item-title {
    line-height: 1.29;
  }

  .block-list__item-text {
    line-height: 1.5;
    letter-spacing: 0.2px;
  }

  @media screen and (min-width: $breakpoint-sm) {
    .block-list__plus-icon {
      position: relative;
      top: 5px;
    }
  }

  @media screen and (max-width: $breakpoint-sm) {
    .block-list__title {
      font-size: 24px;
      line-height: 1.29;
    }

    .block-list__item-title {
      font-size: 18px;
      line-height: 1.44;
    }

    .block-list__item-text {
      font-size: 14px;
      line-height: 1.57;
    }
  }
}
</style>
